import React, {useEffect} from 'react'
import {Time} from 'yougile-util'
import {DropdownContent} from '@components/common/dropdown/dropdown-content'
import {DropdownButton} from '@components/common/dropdown-list/dropdown-button'
import {BooleanHookState, useBoolean} from '@containers/hooks'
import {DropdownProps} from '../dropdown/dropdown'
import {TablerIcons} from '../icon-tabler/icon-tabler'
import {DatePicker} from './date-picker'

interface Props {
  initialDate: Date
  onChoose: (date: Date) => void
  onOpenChange?: (isOpen: boolean) => void
  disablePastDates?: boolean
  header?: string
  large?: boolean
  valid?: BooleanHookState
  showTimeInput?: boolean
  onlyText?: boolean
  textClassName?: string
  icon?: TablerIcons
  iconClassName?: string
  customFormatDate?: (date: number) => string
  placement?: DropdownProps['placement']
  hideArrow?: boolean
}

const formatDate = ({
  initialDate,
  showTimeInput,
  customFormatDate
}: {
  initialDate: Date
  showTimeInput?: boolean
  customFormatDate?: (date: number) => string
}) => {
  const timestamp = Time.toTimestamp(initialDate)
  if (customFormatDate) {
    return customFormatDate(timestamp)
  }

  if (showTimeInput) {
    return Time.formatDateTime(timestamp, false, false, true, true, true)
  }

  return Time.formatDate(timestamp, {
    alwaysWithYear: true,
    fullMonth: true
  })
}

export const DateInput = (props: Props) => {
  const {
    large,
    disablePastDates,
    header,
    initialDate,
    onChoose,
    onOpenChange,
    showTimeInput,
    valid,
    onlyText,
    textClassName,
    icon,
    iconClassName,
    customFormatDate,
    placement,
    hideArrow
  } = props
  const openState = useBoolean(false)
  const isOpen = openState.value
  useEffect(() => onOpenChange?.(isOpen), [isOpen])

  return (
    <DropdownButton
      open={isOpen}
      hideArrow={hideArrow}
      onOpenChange={openState.setValue}
      large={large}
      onlyText={onlyText}
      textClassName={textClassName}
      icon={icon}
      iconClassName={iconClassName}
      placement={placement}
      content={
        <DropdownContent header={header}>
          <DatePicker
            value={initialDate}
            onChange={date => date && onChoose(date)}
            disablePastDates={disablePastDates}
            valid={valid}
            showTimeInput={showTimeInput}
          />
        </DropdownContent>
      }
    >
      {formatDate({initialDate, showTimeInput, customFormatDate})}
    </DropdownButton>
  )
}
